import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';

import { useSnackBar } from '../../../../../hooks/snackBar';

import {
    detalhesCdBuyer,
    cadastrarCd,
    inativarCd,
    atualizarCd,
    ativarCd
} from '../../../../../services/http/buyerService'

import { buscarEnderecoPorCep } from '../../../../../services/http/cepService';

import services from '../../../../../services';

import { useFormik } from 'formik';
import { formCdValidator, mapearData, formCdInitialState, mapearResponseApi } from './formCdValidator';
import { estados, cidadesBrasil } from '../../../../../services/estadosBrasil';

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import './styles.scss';

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250
        }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};

const FormCd = ({cancelar, idCd}) => {
    
    const { idEmpresa } = useParams();
    const { addSnackBar } = useSnackBar();

    const [empresaCd, setEmpresaCd] = useState(formCdInitialState)
    const [cidades, setCidades] = useState([]);
    const [campoCd, setCampoCd] = useState(false);

    const formik = useFormik({
        initialValues: empresaCd,
        validationSchema: formCdValidator,
        onSubmit: (values) => {
            if (idCd) {
                handleAtualizar(values);    
            } else {
                handleSalvar(values);
            }
        },
    })

    useEffect(() => {
        if (idCd) {
            setCampoCd(true);
            CarregarDetalhesCdBuyer();
        } else {
            console.log(idCd);
            setCampoCd(false);
        }
    }, []);

    const CarregarDetalhesCdBuyer = () => {
        trackPromise(
            detalhesCdBuyer(idCd)
                .then(res => {
                    console.log(res);
                    if (res.data) {
                        let data = mapearResponseApi(res.data);
                        formik.setValues(data);
                    }
                }).catch(error => {
                    console.log(error);
                    addSnackBar({ 
                        message: 'Erro ao tentar obter informações de cadastro',
                        info: 'error',
                        open: true 
                    });
                })
        )
    }

    const enderecoPorCep = (cep) => {
        trackPromise(
            buscarEnderecoPorCep(cep)
                .then(res => {
                    if (!res.fail && res.data.uf.sigla){
                        listarCidadesBrasil(res.data.uf.sigla);

                        formik.setValues((prevent) => ({
                            ...prevent,
                            cep: res.data.cep,
                            logradouro: res.data.logradouro,
                            bairro: res.data.bairro,
                            estado: res.data.uf.sigla,
                            cidade: res.data.cidade.nome
                        }))
                    }
                })
        ).catch(error => {
            console.log(error);
        })
    }

    const handleSalvar = (values) => {
        values.cnpj = services.mask.unMask(values.cnpj);
        values.cep = services.mask.unMask(values.cep);
        values.telefone = services.mask.unMask(values.telefone);
        values.tipo = values.tipo === 'selecione' ? '' : values.tipo;
        let data = mapearData(values);

        trackPromise(
            cadastrarCd(idEmpresa, data)
                .then(res => {
                    console.log(res);
                    if (res.fail) {

                        res.errors.forEach(item => {
                            addSnackBar({ 
                                message: item.menssagem,
                                info: 'warning',
                                open: true 
                            });
                        });
                        return;    
                    }

                    addSnackBar({ 
                        message: 'Cadastrado com sucesso',
                        info: 'success',
                        open: true 
                    }); 

                    handleCancelar();

                }).catch(error => {
                    addSnackBar({ 
                        message: 'Erro ao tentar cadastrar',
                        info: 'error',
                        open: true 
                    });
                })
        )
    }

    const handleAtualizar = (values) => {
        values.cnpj = services.mask.unMask(values.cnpj);
        values.cep = services.mask.unMask(values.cep);
        values.telefone = services.mask.unMask(values.telefone);
        values.tipo = values.tipo === 'selecione' ? '' : values.tipo;

        let data = mapearData(values);

        trackPromise(
            atualizarCd(idCd, data)
                .then(res => {
                    if (res.fail) {
                        res.errors.forEach(item => {
                            addSnackBar({ 
                                message: item.menssagem,
                                info: 'warning',
                                open: true 
                            });
                        });
                        return;    
                    }

                    addSnackBar({ 
                        message: 'CD atualizado com sucesso',
                        info: 'success',
                        open: true 
                    }); 

                    handleCancelar();

                }).catch(error => {
                    addSnackBar({ 
                        message: 'Erro ao atualizar CD',
                        info: 'error',
                        open: true 
                    });
                })
        )
    }

    const listarCidadesBrasil = (uf) => {
        trackPromise(
            cidadesBrasil(uf)
                .then(res =>{
                    if (res.data) {
                        setCidades(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar as cidades', info: 'warning', open: true });
                    }
                }).catch(error => {
                    addSnackBar({ message: 'Erro aa carregar cidades', info: 'error', open: true });
                })
        )
    }

    useEffect(() => {
        preencherCidades(formik.values.estado)
    },[formik.values.estado])

    const preencherCidades = (value) => {
        if (value !== '') {
            listarCidadesBrasil(value);
        }
    }

    const handleCancelar = () => {
        cancelar(2);
    }

    const handleInativarCdBuyer = () => {
        trackPromise(
            inativarCd(idCd)
                .then(res => {
                    addSnackBar({
                        message: 'CD inativado com sucesso',
                        info: 'success',
                        open: true
                    })

                    handleCancelar();
                })
        ).catch(error => {
            console.log(error);
        })
    }

    const handleAtivarCdBuyer = () => {
        trackPromise(
            ativarCd(idCd)
                .then(res => {
                    addSnackBar({
                        message: 'CD ativado com sucesso',
                        info: 'success',
                        open: true
                    })

                    handleCancelar();
                })
        ).catch(error => {
            console.log(error);
        })
    }

    return (
        <form className="ml-1 mt20" onSubmit={formik.handleSubmit}>
            <div className="row"><div className="col-sm-12 col-md-12 col-lg-12 font"><strong>Dados da Empresa</strong></div></div>
            
                { 
                    campoCd === true ?
                    <div  className="row">
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <FormControl>
                                <TextField 
                                    label="# ID" 
                                    placeholder="00000000000000" 
                                    type="text" 
                                    size="small"
                                    id="idCd"
                                    disabled
                                    variant="outlined"
                                    value={formik.values.codigo.toString().padStart(6, '0')}
                                    onChange={formik.handleChange}
                                    error={formik.touched.codigo && Boolean(formik.errors.codigo)}
                                    helperText={formik.touched.codigo && formik.errors.codigo}
                                />
                            </FormControl>
                        </div>
                        </div>
                        : null
                }
            <div className="row">
                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                        <TextField
                            label="CNPJ *" 
                            placeholder="00000000000000" 
                            type="text" 
                            size="small"
                            id="cnpj" 
                            variant="outlined"
                            value={services.mask.cpfCnpj(formik.values.cnpj)}
                            onChange={formik.handleChange}
                            error={formik.touched.cnpj && Boolean(formik.errors.cnpj)}
                            helperText={formik.touched.cnpj && formik.errors.cnpj}
                        />
                    </FormControl>
                </div>
                
                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                        <TextField 
                            label="IE" 
                            placeholder="000000" 
                            type="text" 
                            size="small"
                            id="ie" 
                            variant="outlined"
                            value={formik.values.ie}
                            onChange={formik.handleChange}
                            error={formik.touched.ie && Boolean(formik.errors.ie)}
                            helperText={formik.touched.ie && formik.errors.ie}
                        />
                    </FormControl>
                </div>

                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                        <TextField 
                            label="IM" 
                            placeholder="000000" 
                            type="text" 
                            size="small"
                            id="im" 
                            variant="outlined"
                            value={formik.values.im}
                            onChange={formik.handleChange}
                            error={formik.touched.im && Boolean(formik.errors.im)}
                            helperText={formik.touched.im && formik.errors.im}
                        />
                    </FormControl>
                </div>

                <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                        <TextField
                            label="Razão Social *" 
                            placeholder="Informe a Razão Social" 
                            type="text" 
                            size="small"
                            id="razaoSocial" 
                            variant="outlined"
                            value={formik.values.razaoSocial}
                            onChange={formik.handleChange}
                            error={formik.touched.razaoSocial && Boolean(formik.errors.razaoSocial)}
                            helperText={formik.touched.razaoSocial && formik.errors.razaoSocial}
                        />
                    </FormControl>
                </div>

                <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                        <TextField
                            label="Nome Fantasia *" 
                            placeholder="Informe o Nome Fantasia" 
                            type="text" 
                            size="small"
                            id="nomeFantasia" 
                            variant="outlined"
                            value={formik.values.nomeFantasia}
                            onChange={formik.handleChange}
                            error={formik.touched.nomeFantasia && Boolean(formik.errors.nomeFantasia)}
                            helperText={formik.touched.nomeFantasia && formik.errors.nomeFantasia}
                        />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div  className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                        <TextField
                            label="Telefone" 
                            placeholder="00 00000-0000" 
                            type="text" 
                            size="small"
                            id="telefone" 
                            variant="outlined"
                            value={services.mask.phoneoucelularuser(formik.values.telefone)}
                            onChange={formik.handleChange}
                            error={formik.touched.telefone && Boolean(formik.errors.telefone)}
                            helperText={formik.touched.telefone && formik.errors.telefone}
                        />
                    </FormControl>
                </div>
                
                <div  className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                        <TextField
                            label="CEP" 
                            placeholder="00000-000" 
                            type="text" 
                            size="small"
                            id="cep" 
                            variant="outlined"
                            onBlur={event => enderecoPorCep(event.target.value)}
                            value={services.mask.cep(formik.values.cep)}
                            onChange={formik.handleChange}
                            error={formik.touched.cep && Boolean(formik.errors.cep)}
                            helperText={formik.touched.cep && formik.errors.cep}
                        />
                    </FormControl>
                </div>

                <div  className="col-sm-5 col-md-5 col-lg-5">
                    <FormControl>
                        <TextField
                            label="Logradouro" 
                            placeholder="Informe o endereço" 
                            type="text" 
                            size="small"
                            id="logradouro" 
                            variant="outlined"
                            value={formik.values.logradouro}
                            onChange={formik.handleChange}
                            error={formik.touched.logradouro && Boolean(formik.errors.logradouro)}
                            helperText={formik.touched.logradouro && formik.errors.logradouro}
                        />
                    </FormControl>
                </div>

                <div  className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                        <TextField
                            label="Número" 
                            placeholder="000000" 
                            type="text" 
                            size="small"
                            id="numero" 
                            variant="outlined"
                            value={formik.values.numero}
                            onChange={formik.handleChange}
                            error={formik.touched.numero && Boolean(formik.errors.numero)}
                            helperText={formik.touched.numero && formik.errors.numero}
                        />
                    </FormControl>
                </div>

            </div>
            <div className="row">         
                <div  className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                        <TextField
                            label="Complemento"
                            placeholder="Informe o complemento"
                            type="text" 
                            size="small"
                            id="complemento" 
                            variant="outlined"
                            value={formik.values.complemento}
                            onChange={formik.handleChange}
                            error={formik.touched.complemento && Boolean(formik.errors.complemento)}
                            helperText={formik.touched.complemento && formik.errors.complemento}
                        />
                    </FormControl>
                </div>

                <div  className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                        <TextField
                            label="Bairro" 
                            placeholder="Informe o Bairro" 
                            type="text" 
                            size="small"
                            id="bairro" 
                            variant="outlined"
                            value={formik.values.bairro}
                            onChange={formik.handleChange}
                            error={formik.touched.bairro && Boolean(formik.errors.bairro)}
                            helperText={formik.touched.bairro && formik.errors.bairro}
                        />
                    </FormControl>
                </div>

                <div  className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                    <InputLabel id="demo-simple-select-helper-label">Estado</InputLabel>
                        <Select
                            className="select"
                            variant="outlined"
                            id="estado"
                            value={formik.values.estado.toUpperCase() || 'selecione'}
                            label="Estado"
                            onChange={formik.handleChange('estado')}
                            MenuProps={MenuProps}
                            error={formik.touched.estado && Boolean(formik.errors.estado)}
                        >
                            <MenuItem disabled={true} value={"selecione"}>
                                <em>Selecione o estado</em>
                            </MenuItem>

                            {estados.map(es =>
                                <MenuItem value={es}>{es}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </div>

                <div  className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                    <InputLabel id="demo-simple-select-helper-label">Cidade</InputLabel>
                        <Select
                            className="select"
                            id="cidade"
                            variant="outlined"
                            value={formik.values.cidade.toUpperCase() || 'selecione'}
                            label="Cidade"
                            onChange={formik.handleChange('cidade')}
                            MenuProps={MenuProps}
                            error={formik.touched.cidade && Boolean(formik.errors.cidade)}
                        >
                            <MenuItem disabled={true} value={"selecione"}>
                                <em>Selecione sua cidade</em>
                            </MenuItem>

                            {cidades.map(cd =>
                                <MenuItem value={cd.nome.toUpperCase()}>{cd?.nome}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-9 col-md-9 col-lg-9">
                    <FormControl>
                        <TextField 
                            label="URL Google Maps" 
                            placeholder="Informe a URL" 
                            type="text" 
                            size="small"
                            id="urlGoogleMaps" 
                            variant="outlined"
                            value={formik.values.urlGoogleMaps}
                            onChange={formik.handleChange}
                            error={formik.touched.urlGoogleMaps && Boolean(formik.errors.urlGoogleMaps)}
                            helperText={formik.touched.urlGoogleMaps && formik.errors.urlGoogleMaps}
                        />
                    </FormControl>
                </div>
                <div  className="col-sm-3 col-md-3 col-lg-3">
                <FormControl>
                <InputLabel id="demo-simple-select-helper-label">Tipo *  </InputLabel>
                        <Select
                            required
                            className="select"
                            variant="outlined"
                            id="tipo"
                            value={(formik.values.tipo!=null&&formik.values.tipo!=''?formik.values.tipo:'selecione') }
                            label="Tipo"
                            onChange={formik.handleChange('tipo')}
                            MenuProps={MenuProps}
                            error={formik.touched.tipo && Boolean(formik.errors.tipo)}
                        >
                            <MenuItem disabled={true} value={"selecione"}>
                                <em>Selecione o tipo *</em>
                            </MenuItem>
                            <MenuItem value={"CD"}>CD</MenuItem>
                            <MenuItem value={"Loja"}>Loja</MenuItem>
                            <MenuItem value={"Unidade de negócio"}>Unidade de negócio</MenuItem>
                        </Select>
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 mt20 font">
                    <strong>Carga e Descarga</strong>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                        <TextField
                            label="Horário de atendimento"
                            type="select" 
                            size="small"
                            id="horarioAtendimento" 
                            variant="outlined"
                            value={formik.values.horarioAtendimento}
                            onChange={formik.handleChange}
                            error={formik.touched.horarioAtendimento && Boolean(formik.errors.horarioAtendimento)}
                            helperText={formik.touched.horarioAtendimento && formik.errors.horarioAtendimento}
                        />
                    </FormControl>
                </div>
                <div  className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                        <TextField
                            label="Contato"
                            type="text" 
                            size="small"
                            id="contato" 
                            variant="outlined"
                            value={formik.values.contato}
                            onChange={formik.handleChange}
                            error={formik.touched.contato && Boolean(formik.errors.contato)}
                            helperText={formik.touched.contato && formik.errors.contato}
                        />
                    </FormControl>
                </div>
                <div className="col-sm-5 col-md-5 col-lg-5">
                    <FormControl>
                        <TextField
                            label="Observações adicionais"
                            type="text" 
                            size="small"
                            id="observacoes" 
                            variant="outlined"
                            value={formik.values.observacoes}
                            onChange={formik.handleChange}
                            error={formik.touched.observacoes && Boolean(formik.errors.observacoes)}
                            helperText={formik.touched.observacoes && formik.errors.observacoes}
                        />
                    </FormControl>
                </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12  flex flex-end buttons">
                {
                    !idCd && (
                        <button
                            type="button" 
                            className="col-sm-3 col-md-3 col-lg-3 buton-white-black-border"
                            onClick={handleCancelar}

                        >
                            CANCELAR
                        </button>
                    )
                }
                <button 
                    className={idCd
                        ? 'col-sm-6 col-md-6 col-lg-6 buton-green'
                        : 'col-sm-3 col-md-3 col-lg-3 buton-green'
                    }
                    type='submit'
                >
                    SALVAR
                </button>
            </div>
            {
                idCd && (
                    <div className="col-sm-12 col-md-12 col-lg-12  flex flex-end buttons">
                        <button
                            type="button" 
                            className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border"
                            onClick={handleCancelar}

                        >
                            CANCELAR
                        </button>
                        {
                            idCd && (
                                formik.values.ativo
                                ? <button 
                                      type="button"
                                      className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border"
                                      onClick={handleInativarCdBuyer}
                                  >
                                      INATIVAR
                                  </button>
                                : <button 
                                    type="button"
                                    className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border"
                                    onClick={handleAtivarCdBuyer}
                                  >
                                      ATIVAR
                                  </button>
                            )
                        }
                    </div>
                )
            }

        </form>
    )
}

export default FormCd;